import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./EditarLead.css";

function EditarLead() {
  const { lead_id } = useParams();
  const navigate = useNavigate(); 

  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    origem_lead: "",
    interesse: "",
    estagio_funil: "",
    observacao: "",
  });

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [tagsDisponiveis, setTagsDisponiveis] = useState([]);
  const [tagsSelecionadas, setTagsSelecionadas] = useState([]);


  useEffect(() => {
    fetchLeadDetails();
    carregarTags();

}, []);


const carregarTags = async () => {
  try {
    const res = await fetch("https://welaunchyou.com.br/crm-wly/tags.php?lista=1", {
      credentials: "include",
    });
    const data = await res.json();

    const lista = Array.isArray(data)
      ? data
      : Array.isArray(data.tags)
      ? data.tags
      : Array.isArray(data.resumo)
      ? data.resumo
      : [];

    setTagsDisponiveis(lista);
  } catch (err) {
    console.error("Erro ao carregar tags:", err);
    setTagsDisponiveis([]);
  }
};



const handleDelete = async () => {
  if (!window.confirm("Tem certeza que deseja excluir este lead? Esta ação não pode ser desfeita.")) {
      return;
  }

  setLoading(true);
  setMessage("");
  setError("");

  try {
      const response = await fetch(`https://welaunchyou.com.br/crm-wly/editar_lead.php?lead_id=${lead_id}`, {
          method: "DELETE",
          credentials: "include",
      });

      const data = await response.json();
      console.log("📩 Resposta do servidor (exclusão):", data);

      if (response.ok) {
          alert("Lead excluído com sucesso!");
          navigate("/leads"); // Redireciona para a lista de leads
      } else {
          setError(data.error || "Erro ao excluir lead.");
      }
  } catch (err) {
      console.error("❌ Erro ao conectar ao servidor:", err);
      setError("Erro ao conectar ao servidor.");
  } finally {
      setLoading(false);
  }
};


  const fetchLeadDetails = async () => {
    try {
      const response = await fetch(`https://welaunchyou.com.br/crm-wly/editar_lead.php?lead_id=${lead_id}`, {
        credentials: "include",
      });

      const data = await response.json();

      if (response.ok) {
        setFormData(data.lead);
      } 
      
      if (data.tags) {
  setTagsSelecionadas(data.tags.map(tag => tag.id.toString())); 
}

else {
        setError(data.error || "Erro ao carregar lead.");
      }
    } catch (err) {
      setError("Erro ao conectar com o servidor.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/editar_lead.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ lead_id, ...formData, tags: tagsSelecionadas }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setTimeout(() => navigate("/listagem-leads"), 2000);
      } else {
        setError(data.error || "Erro ao atualizar lead.");
      }
    } catch (err) {
      setError("Erro ao conectar com o servidor.");
    }
  };

  if (loading) return <p>Carregando...</p>;

  return (
  <div className="editar-lead-container-texto">
     <h1>Editar Lead</h1>
    <div className="editar-lead-container">
     

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="nome">Nome:</label>
          <input type="text" id="nome" name="nome" value={formData.nome} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="telefone">Telefone:</label>
          <input type="text" id="telefone" name="telefone" value={formData.telefone} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label htmlFor="origem_lead">Origem do Lead:</label>
          <select id="origem_lead" name="origem_lead" value={formData.origem_lead} onChange={handleChange} required>
            <option value="">Selecione</option>
            <option value="Facebook">Facebook</option>
            <option value="Instagram">Instagram</option>
            <option value="Google Ads">Google Ads</option>
            <option value="Indicação">Indicação</option>
            <option value="Nórea CRM">Nórea CRM</option>

          </select>
        </div>

        <div className="form-group">
          <label htmlFor="interesse">Interesse:</label>
          <input type="text" id="interesse" name="interesse" value={formData.interesse} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label htmlFor="estagio_funil">Estágio do Funil:</label>
          <select id="estagio_funil" name="estagio_funil" value={formData.estagio_funil} onChange={handleChange} required>
            <option value="">Selecione</option>
            <option value="Contato Inicial">Contato Inicial</option>
            <option value="Qualificação">Qualificação</option>
            <option value="Agendamento">Agendamento</option>
            <option value="Acompanhamento">Acompanhamento</option>
            <option value="Agendado">Agendado</option>
            <option value="Cliente">Cliente</option>

          </select>
        </div>

        <div className="form-group">
          <label htmlFor="observacao">Observação:</label>
          <textarea type="textarea" id="observacao" name="observacao" value={formData.observacao} onChange={handleChange} rows="3" ></textarea>   
        </div>

        <div className="form-group">
  <label>Tags:</label>
  <div className="checkbox-container">
      {(tagsDisponiveis || []).map(tag => (
    <label key={tag.id} className="checkbox-item" title={tag.nome}>
      <input
        type="checkbox"
        value={tag.id}
        checked={tagsSelecionadas.includes(tag.id.toString())}
        onChange={(e) => {
          const tagId = e.target.value;
          setTagsSelecionadas((prev) =>
            e.target.checked
              ? [...prev, tagId]
              : prev.filter((id) => id !== tagId)
          );
        }}
      />
      {tag.nome}
    </label>
  ))}
</div>
                {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}
</div>


        <div className="presets2">

        <button type="submit"  className="atualizar-button">Atualizar</button>
        <button type="button" className="delete-button"
    onClick={handleDelete}
    disabled={loading}>
    {loading ? "Excluindo..." : "Excluir Lead"}
</button>
</div>
      </form>
      </div>
    </div>
  );
}

export default EditarLead;
